/* Lucky Number 24 — Browse Numbers deep links: /pages/browse-numbers?area=617 (or ?state=MA) pre-selects the search. */
(function(){
  if(!document.getElementById('ln24-browse'))return;
  var q=new URLSearchParams(location.search),area=(q.get('area')||'').replace(/\D/g,'').slice(0,3),st=(q.get('state')||'').toUpperCase();
  if(!area&&!st)return;
  function go(){
    if(!window.ln24bPopulateAreaCodes||!window.LN24_STATE_AC||!window.ln24bFetchLive)return setTimeout(go,50);
    var map=window.LN24_STATE_AC;
    if(area&&!st){Object.keys(map).forEach(function(k){if(map[k].indexOf(area)>-1)st=k;});}
    if(st&&!map[st])st='';
    var tf=(window.LN24_TOLLFREE_NPAS||[]).indexOf(area)>-1;
    if(tf){window.ln24bSetMode('tollfree');document.getElementById('ln24b-ss-area').value=area;window.ln24bFetchLive();return;}
    var orig=window.ln24bPopulateAreaCodes,locked=true;
    function apply(){var s=document.getElementById('ln24b-ss-state'),a=document.getElementById('ln24b-ss-area');s.value=st;orig(st);if(area)a.value=area;}
    window.ln24bPopulateAreaCodes=function(x){if(locked){apply();return;}return orig(x);};
    function unlock(){locked=false;}
    ['ln24b-ss-state','ln24b-ss-area'].forEach(function(id){var e=document.getElementById(id);if(e)e.addEventListener('change',unlock,true);});
    document.addEventListener('click',function(e){if(e.target&&e.target.closest&&e.target.closest('.ln24b-clear,.ln24f-clear'))unlock();},true);
    window.ln24bGeoFallbackDone=true;
    apply();window.ln24bFetchLive();
    /* a slower geo-based search started before this script can finish last and overwrite results: re-run until results match */
    var tries=0,t=setInterval(function(){
      if(!locked||tries>=4){clearInterval(t);return;}
      var L=window.LN24B_LIVE||[];if(!L.length)return;
      var ok=area?L.some(function(n){return String(n.display_number).indexOf('('+area+')')>-1;}):true;
      if(ok){clearInterval(t);return;}
      tries++;apply();window.ln24bFetchLive();
    },900);
  }
  go();
})();
